import React, { useEffect, useRef, useState } from "react";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import Swal from "sweetalert2";
import * as Yup from 'yup'
import { useDispatch } from "react-redux";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import { Col, Row } from "react-bootstrap";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { failureAlert } from "../CommonUtils/SweetAlerts";
import CommonFormHeading from "../CommonUtils/CommonFormHeading";

export default function AffiliationLabCouseMapOamdc() {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const hasFetchedData = useRef(false);
    const [flag, setFlag] = useState(false);
    const [labs, setLabs] = useState([]);
    const [courseCode, setCourseCode] = useState('');
    const [labname, setLabname] = useState('');

    const validationSchema = Yup.object().shape({
        labDetails: Yup.array().of(
            Yup.object().shape({
                labDetails: Yup.string().required(ERROR_MSG).nullable(),
            })
        ),
    });


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            courseCode: courseCode || '',
            labDetails: [],
        },
        validationSchema: validationSchema,
        onSubmit: (val) => {
            formik.validateForm().then((errors) => {
                if (Object.keys(errors).length === 0) {
                    const labfinalvalues = {
                        courseCode: courseCode || '',
                        labDetails: val?.labDetails?.map((item) => item?.labDetails),
                    };
                    Swal.fire({
                        text: 'Are you sure you want to submit?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, submit it!',
                        cancelButtonText: 'No, cancel!',
                        backdrop: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            const url = config.url.API_URL + `LabAreaMappingDetails`;
                            CommonAxiosPost(url, labfinalvalues, dispatch).then((res) => {
                                if (res?.data?.scode === '01') {
                                    Swal.fire(res?.data?.sdesc, '', 'success').then(() => {
                                        window.location.reload();
                                    });
                                } else {
                                    failureAlert("Failed to submit")
                                }
                            });
                        }
                    });
                } else {
                    console.log('Validation errors:', errors);
                }
            });
        },
    });

    // Fetch available lab courses
    async function GetData() {
        try {
            const url = `${config.url.API_URL}getlabCourses`;
            const res = await CommonAxiosGet(url, dispatch);
            if (res?.data?.scode === '01') {
                setData(res?.data?.Courses);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error('Error fetching lab courses:', error);
            setData([]);
        }
    }

    // Fetch labs based on courseId
    async function GetLablist(crsId) {
        try {
            const urll = `${config.url.API_URL}getlabsList/${crsId}`;
            const res = await CommonAxiosGet(urll, dispatch);
            if (res?.data?.scode === '01') {
                const fetchedLabs = res?.data?.labsList || [];
                const areaDetails =
                    fetchedLabs.length > 0
                        ? fetchedLabs.map((lab) => ({
                            labDetails: lab?.lab_details || '',
                        }))
                        : [{ labDetails: '' }];
                formik.setFieldValue('labDetails', areaDetails);
            } else {
                formik.setFieldValue('labDetails', [{ labDetails: '' }]);
            }
        } catch (error) {
            console.error('Error fetching labs:', error);
            formik.setFieldValue('labDetails', [{ labDetails: '' }]);
        }
    }

    // Fetch all available labs
    async function GetLabDetails() {
        try {
            const urll = `${config.url.API_URL}getlabs`;
            const res2 = await CommonAxiosGet(urll, dispatch);
            if (res2?.data?.scode === '01') {
                setLabs(res2?.data?.labs);
            } else {
                setLabs([]);
            }
        } catch (error) {
            console.error('Error fetching labs:', error);
            setLabs([]);
        }
    }

    // Columns for your React Table
    const Columns = [
        {
            Header: 'Sl.no',
            accessor: (row, index) => index + 1,
        },
        {
            Header: 'Single Major Programme',
            accessor: 'details',
            Cell: ({ row }) => (
                <div className="text-left">{row?.values?.details ? row?.values?.details : <b style={{ textAlign: 'center' }}>-</b>}</div>
            ),
        },
        {
            Header: 'Total Labs',
            accessor: 'tot',
            Cell: ({ row }) => (
                <div>
                    <button type="button" onClick={() => {
                        setFlag(true);
                        setCourseCode(row?.original?.course_id);
                        GetLabDetails();
                        GetLablist(row?.original?.course_id);
                        setLabname(row?.original?.details);
                    }}
                        style={{
                            cursor: 'pointer',
                            color: "blue"
                        }}
                        className="text-center">
                        {row?.values?.tot === 0 ? 'Please Add Labs' : row?.values?.tot}
                    </button>
                </div>
            ),
        },
    ];

    // Fetch the data once on mount
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetData();
            hasFetchedData.current = true;
        }
    }, []);

    // Handle duplicate selection in the dropdown
    const handleSelectionChange = (selectedValue, index) => {
        const selectedValues = formik?.values?.labDetails
            .map((detail, i) => (i !== index ? detail?.labDetails : null))
            .filter((value) => value);
        if (selectedValues.includes(selectedValue)) {
            Swal.fire('This value is already selected in another row.', '', "info");
            setTimeout(() => {
                formik.setFieldValue(`labDetails[${index}].labDetails`, '');
            }, 0);
        }
    };

    return (
        <div className="affl-newdiv">
            <div className="container-fluid px-1">
                {!flag ? (<>
                    <CommonFormHeading heading="Lab Course Mapping" />



                    <div className="container shadow-none px-3 m-0 mw-100 pb-5">
                        {data && data?.length > 0 ? (<div className="table-responsive"><CommonReactTable data={data} columns={Columns} filename="Lab Course Map" headerName={`Lab Course Map`} /></div>) :
                            (<center center className='text-danger h5 pt-5'>***** No Data Found *****</center>)}
                    </div>
                </>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-12">
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>
                                        <div className="inner-herbpage-service-title1">
                                            <h1>Lab Course Mapping</h1>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                        <div className='d-flex flex-row justify-content-end'>
                                            <button type="button" className='btn btn-sm btn-secondary'
                                                onClick={() => { setFlag(false) }}>Back</button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="container shadow-none px-3 m-0 mw-100 pb-5" style={{ backgroundColor: '#FAF7F0' }}>
                            <div className="inner-herbpage-service-title-sub pt-0">
                                <h1 className="">{labname} Course</h1>
                            </div>
                            <FormikProvider value={formik}>
                                <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit}>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th className="text-left">Name of the Lab</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <FieldArray name="labDetails">
                                                    {({ push, remove }) => (
                                                        <>
                                                            {formik.values.labDetails.map((detail, index) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <center>{index + 1}</center>
                                                                    </td>
                                                                    <td>
                                                                        <Field
                                                                            as="select"
                                                                            className="form-control"
                                                                            name={`labDetails[${index}].labDetails`}
                                                                            style={{ width: '100%' }}
                                                                            onChange={(e) => {
                                                                                formik.handleChange(e);
                                                                                handleSelectionChange(e.target.value, index);
                                                                            }}
                                                                        >
                                                                            <option value="">--Select--</option>
                                                                            {labs?.length > 0 &&
                                                                                labs.map((lab, i) => (
                                                                                    <option key={i} value={lab.lab_details}>
                                                                                        {lab.lab_details}
                                                                                    </option>
                                                                                ))}
                                                                        </Field>
                                                                        <ErrorMessage
                                                                            name={`labDetails[${index}].labDetails`}
                                                                            component="div"
                                                                            className="text-error"
                                                                        />
                                                                    </td>
                                                                    <td align="center">
                                                                        {index === 0 && (
                                                                            <button
                                                                                type="button"
                                                                                className="button-title btn btn-sm btn-success"
                                                                                onClick={() => {
                                                                                    push({ labDetails: '' });
                                                                                }}
                                                                            >
                                                                                <VscDiffAdded />
                                                                            </button>
                                                                        )}
                                                                        {index >= 1 && (
                                                                            <button
                                                                                type="button"
                                                                                className="button-title btn btn-sm btn-danger"
                                                                                onClick={() => {
                                                                                    remove(index);
                                                                                }}
                                                                            >
                                                                                <BiTrash />
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    )}
                                                </FieldArray>
                                            </tbody>
                                        </table>
                                    </div>
                                    <button type="submit" className="btn btn-success btn-sm float-end">
                                        Submit
                                    </button>
                                </Form>
                            </FormikProvider>
                        </div>
                    </>
                )}
            </div>
        </div >
    );
}
